import React from 'react';
import Navbar from '../components/Navbar';
import '../styles/contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <Navbar />

      {/* Hero Section */}
      <section className="contact-hero">
        <div>
          <img
            src="/images/landscape/LandscapeHero5.jpg"
            alt="Contact All Seasons Landscaping"
            className="hero-image"
            loading="eager"
            decoding="async"
          />
        </div>
        <div className="contact-hero-overlay">
          <div className="contact-hero-content">
            <h1 className="contact-hero-title">Get In Touch</h1>
            <p className="contact-hero-subtitle">
              Ready to transform your landscape? We're here to help.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info-section">
        <div className="section-inner">
          <div className="contact-grid">

            {/* Phone */}
            <div className="contact-card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Call Us</h3>
              <a href="tel:2087883352" className="contact-link">
                (208) 788-3352
              </a>
              <p className="contact-description">
                Monday - Friday: 8:00 AM - 5:00 PM<br/>
                Emergency Snow Removal: 24/7
              </p>
            </div>

            {/* Email */}
            <div className="contact-card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Email Us</h3>
              <a href="mailto:info@allseasons.info" className="contact-link">
                info@allseasons.info
              </a>
              <p className="contact-description">
                We typically respond within 24 hours
              </p>
            </div>

            {/* Client Portal */}
            <div className="contact-card">
              <div className="contact-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L18.7071 8.70711C18.8946 8.89464 19 9.149 19 9.41421V19C19 20.1046 18.1046 21 17 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>Client Portal</h3>
              <a
                href="https://allseasons.propertyserviceportal.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                Aspire Portal
              </a>
              <p className="contact-description">
                Existing clients can manage services and requests
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Service Area Section */}
      <section className="service-area-section">
        <div className="section-inner">
          <h2 className="section-title">Our Service Area</h2>
          <p className="section-intro">
            Proudly serving the entire Wood River Valley and surrounding communities
          </p>

          <div className="service-area-content">
            <div className="service-area-map">
              <img
                src="/images/Valley.jpeg"
                alt="All Seasons service area covering Wood River Valley including Sun Valley, Ketchum, Hailey, and Bellevue"
              />
              {/* City Markers */}
              <div className="city-marker" style={{ top: '43%', left: '9.5%' }}>
                <div className="marker-dot" data-city="sun-valley"></div>
                <div className="marker-label">Sun Valley</div>
              </div>
              <div className="city-marker" style={{ top: '52%', left: '15.5%' }}>
                <div className="marker-dot" data-city="ketchum"></div>
                <div className="marker-label">Ketchum</div>
              </div>
              <div className="city-marker" style={{ top: '59.5%', left: '59%' }}>
                <div className="marker-dot" data-city="hailey"></div>
                <div className="marker-label">Hailey</div>
              </div>
              <div className="city-marker" style={{ top: '40%', left: '76.5%' }}>
                <div className="marker-dot" data-city="bellevue"></div>
                <div className="marker-label">Bellevue</div>
              </div>
              <div className="city-marker" style={{ top: '39.5%', left: '16.5%' }}>
                <div className="marker-dot" data-city="elkhorn"></div>
                <div className="marker-label">Elkhorn Village</div>
              </div>
            </div>

            <div className="service-area-info">
              <h3>Communities We Serve</h3>
              <ul className="communities-list">
                <li data-city="sun-valley"><span className="city-color-box"></span>Sun Valley</li>
                <li data-city="ketchum"><span className="city-color-box"></span>Ketchum</li>
                <li data-city="hailey"><span className="city-color-box"></span>Hailey</li>
                <li data-city="bellevue"><span className="city-color-box"></span>Bellevue</li>
                <li data-city="elkhorn"><span className="city-color-box"></span>Elkhorn Village</li>
                <li data-city="surrounding"><span className="city-color-box"></span>And surrounding areas</li>
              </ul>
              <p className="service-note">
                Covering the complete Wood River Valley from residential properties to large commercial developments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Social & Gallery Section */}
      <section className="connect-section">
        <div className="section-inner">
          <h2 className="section-title">Connect With Us</h2>

          <div className="connect-grid">

            {/* Social Media */}
            <div className="connect-card">
              <h3>Follow Our Work</h3>
              <p>See our latest projects and seasonal updates</p>
              <div className="social-links">
                <a
                  href="https://www.facebook.com/profile.php?id=61588567298492"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-button facebook"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Facebook
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61588567298492"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-button instagram"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                  </svg>
                  Instagram
                </a>
              </div>
            </div>

            {/* Gallery */}
            <div className="connect-card">
              <h3>View Our Portfolio</h3>
              <p>Explore hundreds of completed projects across the valley</p>
              <a href="/gallery" className="btn-cta">
                Browse Gallery
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* Emergency Contact Banner */}
      <section className="emergency-banner">
        <div className="emergency-content">
          <div className="emergency-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="emergency-text">
            <h3>Emergency Services Available</h3>
            <p>24/7 emergency contact available for our customers during winter months for snow removal and urgent landscape needs</p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;
